import { render, staticRenderFns } from "./ParkingCardPopup.vue?vue&type=template&id=5882a230&lang=pug&"
import script from "./ParkingCardPopup.vue?vue&type=script&lang=ts&"
export * from "./ParkingCardPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ParkingCardPopup.vue?vue&type=style&index=0&id=5882a230&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports